import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const Heart = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("g", { id: "Reaction-/-Meduim-/-Heart_Meduim_24X24", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("path", { d: "M0.409,11.0514 C1.743,15.4504 8.842,20.6224 11.225,22.2554 C11.7,22.5804 12.305,22.5804 12.78,22.2554 C15.162,20.6214 22.255,15.4504 23.591,11.0514 C23.98,9.9234 24.111,8.6584 23.899,7.3424 C23.437,4.4674 21.289,2.1324 18.609,1.6164 C15.897,1.0954 13.417,2.3464 12,4.4694 C10.583,2.3454 8.102,1.0954 5.391,1.6164 C2.711,2.1324 0.563,4.4674 0.1,7.3434 C-0.111,8.6584 0.02,9.9234 0.409,11.0514", id: "Heart", fill: "#F5592D" }))));
};
Heart.displayName = 'Heart';
export default Heart;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Heart.js.map